import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesStatusesTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-statuses-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=status'],
};
